export default {
  ControlledDrugsSafe: "Approved Controlled Drugs Safe",
  CultivarIndustrialHemp: "Approved Cultivar of Industrial Hemp",
  SupplyPrescriptionMeds:
    "Approved Extended Period of Supply of Prescription Medicines",
  FormControlledDrugs: "Approved Prescription Form (Controlled Drugs)",
  ApprovedRecordingSystem: "Approved Recording System",
  VendingMachine:
    "Approved Sales of General Sales Medicines by Vending Machine",
  LocationforRecords: "Approved Storage Location for Records",
  EmergencyMedicalKit: "Authority to Possess Medicines (Emergency Medical Kit)",
  PharmacyDepot: "Authority to Possess Medicines (Pharmacy Depot)",
  Research: "Authority to Possess Medicines (Research/ Study/ Analysis)",
  NoObjection: "Letter of no objection",
  "Industrial HempGeneral": "Licence for Industrial Hemp (General)",
  "Industrial HempResearch":
    "Licence for Industrial Hemp (Research & Breeding)",
  CultivateProhibitedPlant: "Licence to Cultivate a Prohibited Plant",
  DealControlledDrugs: "Licence to Deal in Controlled Drugs",
  ExportControlledDrugs: "Licence to Export Controlled Drugs",
  HawkMedicines: "Licence to Hawk Medicines",
  ImportControlledDrugs: "Licence to Import Controlled Drugs",
  OperatePharmacy: "Licence to Operate Pharmacy",
  PossessControlledDrugs: "Licence to Possess Controlled Drugs",
  Retail: "Licence to Sell Medicines by Retail",
  Wholesale: "Licence to Sell Medicines by Wholesale",
  RestrictionNotice: "Restriction Notice"
};
